/**
 * B000011 ログイン - 端末認証
 */

import { Box, Stack } from "@mui/material";
import {
  B000011Update,
  B000011UpdateRequest,
  B000020Find,
  catchRestError,
} from "clients/rest";
import {
  AuthRoute,
  msgState,
  SCancelButton,
  SFrame,
  SNormalButton,
  SText,
  STextField,
} from "components";
import { SBar } from "components/parts";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authState, focusState, getMenus, menusState, useFocus } from "states";

type Props = Partial<{}>;

type Fields = {
  ninshoKey: string;
};

const defaultFields: Fields = {
  ninshoKey: "",
};

const focusId = "B000011";

export const B000011 = (props: Props) => {
  useFocus(focusId);
  return (
    <AuthRoute>
      <Page {...props} />
    </AuthRoute>
  );
};

const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  const { focus, register } = useRecoilValue(focusState(focusId));
  const auth = useRecoilValue(authState);
  const setMenus = useSetRecoilState(menusState);
  const navigate = useNavigate();
  const setMsg = useSetRecoilState(msgState);

  useEffect(() => {
    focus(1);
  }, [focus]);

  const handleRegister = () => {
    const fields = methods.getValues();
    const param: B000011UpdateRequest = {
      ninshoKey: fields.ninshoKey,
    };
    B000011Update(param)
      .then(() => {
        const kengenId = auth?.kengenId;
        // 権限定義一覧を取得する。
        B000020Find({ kengenId: kengenId })
          .then((value) => {
            setMenus(getMenus(value.data));
            navigate("/");
          })
          .catch((reason) => {
            // 取得できない場合、ログイン画面へ遷移する。
            navigate("/b000010");
          });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  const handleCancel = () => {
    navigate("/b000010");
  };

  return (
    <FormProvider {...methods}>
      <SBar />
      <SFrame title="ログイン - 端末認証">
        <Box display="flex" justifyContent="center" margin={8}>
          <SFrame margin={8}>
            <Stack rowGap="5px">
              <SText>
                端末認証キーを入力し、端末をシステムに登録してください。
              </SText>
              <STextField
                label="端末認証キー"
                name="ninshoKey"
                {...register(1)}
                size={22}
                required
              />
              <Box display="flex" justifyContent="center">
                <Box
                  display="grid"
                  gridTemplateColumns="7rem 7rem"
                  columnGap="20px"
                >
                  <SCancelButton label="キャンセル" onClick={handleCancel} />
                  <SNormalButton
                    label="登録"
                    {...register(2)}
                    onClick={handleRegister}
                  />
                </Box>
              </Box>
            </Stack>
          </SFrame>
        </Box>
      </SFrame>
    </FormProvider>
  );
};
